export const availabilitySortByOptions = [
  {
    code: 'frames',
    name: 'frames',
  },
  {
    code: 'impressions',
    name: 'impressions',
  },
];

export const availabilityGroupByOptions = [
  {
    code: 'town',
    name: 'town',
  },
  {
    code: 'productFormat',
    name: 'product format',
  },
];

export const MAX_AVAILABILITY_VISIBLE_ITEM = 5;

export const distributionGroupPathToValue: Record<string, Record<string, string>> = {
  town: {
    label: 'district.town.townName',
  },
  productFormat: {
    label: 'productFormat.productFormatName',
  },
};
